import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { LoggingService } from '../../../logging.service';
import { NotificationService } from '../../../notification.service';
import { Device, DeviceType } from '../../../shared/models/device.model';
import { AdminService } from '../../admin.service';
import { ProviderOptionGroup } from '../devices';

interface DialogData {
  providerOptions: ProviderOptionGroup[] | null;
}

@Component({
  host: { 'test-id': 'add-device-dialog' },
  selector: 'add-device-dialog',
  styleUrls: ['./add-device-dialog.component.scss'],
  templateUrl: './add-device-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddDeviceDialog {
  private admin = inject(AdminService);
  private data = inject<DialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<AddDeviceDialog, Device>>(MatDialogRef);
  private logger = inject(LoggingService);
  private notification = inject(NotificationService);

  readonly providerOptions = this.data.providerOptions;

  public label = '';
  public provider = 'site';
  public type: DeviceType = DeviceType.Reaper;

  @ViewChild('form', { static: false }) form: NgForm;

  onClose(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    for (const control of Object.values(this.form.controls)) {
      control.markAsTouched();
    }
    if (!this.label) {
      return;
    }
    const payload: Partial<Device> = {
      type: this.type,
      label: this.label,
    };
    if (this.providerOptions) {
      const providerId = ['site', 'project'].includes(this.provider) ? null : this.provider;
      payload.storage_config = providerId
        ? { storage_strategy: 'custom', provider: providerId }
        : { storage_strategy: this.provider as 'site' | 'project' };
    }
    this.admin.addDevice(payload).subscribe(
      (device) => {
        this.notification.success('device.add.success');
        this.dialogRef.close(device);
      },
      (error) => {
        this.notification.error('device.add.error');
        this.logger.error(error);
      },
    );
  }
}
